import type { Agency } from '@saaga/shared/interfaces/agencies.interface'
import { useDeleteAgencyMutation } from '@saaga/shared/store/agency-endpoints.store'
import { useCallback, useState } from 'react'

import { deleteAgency } from './agency-delete.helper'

export interface UseAgencyDeleteConfirmReturn {
  agencyToDelete: Agency | null
  handleDeleteRequest: (agency: Agency) => void
  handleDeleteConfirm: () => void
  handleDeleteCancel: () => void
}

export const useAgencyDeleteConfirm = (): UseAgencyDeleteConfirmReturn => {
  const [agencyToDelete, setAgencyToDelete] = useState<Agency | null>(null)
  const [deleteFn] = useDeleteAgencyMutation()

  const handleDeleteRequest = useCallback((agency: Agency) => {
    setAgencyToDelete(agency)
  }, [])

  const handleDeleteConfirm = useCallback(() => {
    if (!agencyToDelete) return
    deleteAgency(agencyToDelete.slug, agencyToDelete.name, deleteFn)
    setAgencyToDelete(null)
  }, [agencyToDelete, deleteFn])

  const handleDeleteCancel = useCallback(() => {
    setAgencyToDelete(null)
  }, [])

  return { agencyToDelete, handleDeleteRequest, handleDeleteConfirm, handleDeleteCancel }
}
